<template>
  <div id="app" style="overflow-y: auto">
    <!-- 路由 -->
    <transition :name="transitionName">
      <!-- <transition> -->
      <router-view class="router-view" style="height: 100%"></router-view>
    </transition>
    <div class="allmsg" v-for="(item, index) in msglist" :key="index">
            <msg
                v-show="dialogVisible == true && routeName !='login'"
                @close="Dialogclose"
                v-for="(item, index) in msglist"
                :key="index"
                :style="{
                    right: item.rights + 'px',
                    bottom: item.bottoms + 'px',
                }"
            ></msg>
        </div>
    <div>
      <lymsg
        v-show="dialogsVisible == true"
        @lyclose="Dialogsclose"
        style="left: 40px; bottom: 30px"
      ></lymsg>
    </div>
  </div>
</template>

<script>
import msg from "@/components/msg.vue"
import lymsg from "@/components/lymsg.vue"
import exportVue from "@/utils/exportVue"
export default {
  components: {
    msg,
    lymsg,
  },
  data() {
    return {
      routeName: "", //当前展示子路由的路由名称
      transitionName: "", //定义过渡动画名称
       dialogVisible: true,
      dialogsVisible: false,
       msglist: [{ id: 0, rights: "40", bottoms: "30" }],
      // rights: 40,
      // dataIndex: 0,
      // bottoms: 30,
    }
  },
  created() {
    this.getPageUrl()
    // 在页面加载时读取localStorage里的状态信息
    if (localStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(localStorage.getItem("store"))
        )
      )
      localStorage.removeItem("store")
    }
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("pagehide", () => {
      localStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  },

  updated() {
    this.getPageUrl()
  },
  methods: {
    // 获取当前页面路由名称
    getPageUrl() {
      this.routeName = this.$route.name
    },
    Dialogclose(data) {
        this.dialogVisible = data
        exportVue.$emit("istrue", data)
    },
    Dialogsclose(data) {
      this.dialogsVisible = data
      // console.log(data, "data")
      exportVue.$emit("isTrue", data)
    },
  },
  watch: {
    //使用watch 监听$router子路由的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      // to.meta.index : 旧页面的路由meta 在router.js中定义的
      // 通过判断新旧页面的路由meta数值,来对应加载前进后退动画
      if (to.meta.index > from.meta.index) {
        //设置动画名称
        this.transitionName = "slide-left"
      } else {
        this.transitionName = "slide-right"
      }
      this.$store.commit("current", to.path)
    },
  },
}
</script>
<style lang="less">
@import "./assets/css/sectionBox.css";
#app {
  position: relative;
}

.m-t10 {
  margin-top: 10px;
}
// 路由切换的动画样式
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 500ms;
  position: absolute;
}
.slide-right-enter {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-enter {
  opacity: 0;
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  opacity: 0;
  transform: translate3d(-100%, 0, 0);
}
/* 解决element-ui的table表格控件表头与内容列不对齐问题 */
/deep/ .el-table th.gutter {
  display: table-cell !important;
}
/deep/.el-input__suffix {
  margin-top: 0px;
}

.table-box {
  background-color: #fff;
  border-radius: 16px;
  padding: 15px;
  margin: 15px 0;
}

.el-table {
  margin: 15px 0;

  th {
    background-color: #f4fbf2 !important;
    color: #333333 !important;
  }
}

// .el-button--primary {
//   background-color: #4BC716 !important;
//   border: none !important;
// }
</style>
